import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { appRoute } from '@/app/appRoute';
import { str } from '@/lib/search';

export interface HomeSearch {
  /** The attention inbox filtered to one source (tasks, proposals, quality, failed-runs). */
  inbox?: string;
  /** A news post opened from the bell: shown on Home even when read already. */
  news?: string;
}

export const homeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  validateSearch: (s: Record<string, unknown>): HomeSearch => ({ inbox: str(s.inbox), news: str(s.news) }),
  component: lazyRouteComponent(() => import('./HomePage')),
});

/** Personas land on "/home" (server naming); Home lives at "/". */
export const homeAliasRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/home',
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
